import { render, staticRenderFns } from "./Esg4.vue?vue&type=template&id=68633edc&scoped=true"
import script from "./Esg4.vue?vue&type=script&lang=js"
export * from "./Esg4.vue?vue&type=script&lang=js"
import style0 from "./Esg4.vue?vue&type=style&index=0&id=68633edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68633edc",
  null
  
)

export default component.exports